<script setup lang="ts">
const props = defineProps<{
  modelValue: boolean;
  text?: string;
  disabled?: boolean;
}>();
const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <div class="flex flex-row items-center" :class="{ 'text-disabled': props.disabled }">
    <input
      :checked="props.modelValue"
      :disabled="props.disabled"
      type="checkbox"
      class="checkbox-list"
      @change="emit('update:modelValue', ($event.target as HTMLInputElement)?.checked)"
    />
    <span class="ml-2">{{ props.text }}</span>
  </div>
</template>
<style scoped>
.checkbox-list {
  /* native accent color for modern browsers */
  background-color: white;
  /* size the checkbox */
  width: 16px;
  height: 16px;
  /* remove default border */
  border-color: rgb(220, 223, 230);
  outline: none;
  box-shadow: none;
  /* ensure pointer cursor */
  cursor: pointer;
}
.checkbox-list:checked {
  /* native accent color for modern browsers */
  background-color: rgb(85, 182, 145);
  /* size the checkbox */
  width: 16px;
  height: 16px;
  /* remove default border */
  border-color: rgb(85, 182, 145);
  outline: none;
  box-shadow: none;
  /* ensure pointer cursor */
  cursor: pointer;
}
.checkbox-list:hover:checked {
  background-color: rgb(85, 182, 145); /* same as base */
  border-color: rgb(85, 182, 145);
}
.checkbox-list:hover {
  background-color: white; /* same as base */
  border-color: rgb(85, 182, 145);
}
.checkbox-list:focus {
  outline: none;
  box-shadow: none;
}
.checkbox-list:disabled {
  background-color: rgb(168, 171, 178);
  border-color: rgb(168, 171, 178);
  color: black;
  cursor: not-allowed;
}
.text-disabled {
  color: rgb(168, 171, 178); /* Set the text color for the associated label */
}
.checkbox-list:disabled:hover {
  background-color: rgb(168, 171, 178);
  border-color: rgb(168, 171, 178);
  color: black;
}
</style>
